// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rUbM","content":"styles_content__1pELn"};